const setting = {
  namespaced: true,
  state: {
    serviceMode: localStorage.getItem("se_service_mode") || "",
    inventoryModel: localStorage.getItem("se_inventory_model") || "1",
    dispatchMode: localStorage.getItem("se_service_dispatch_mode") || "0",
    serviceModeDesc: localStorage.getItem("se_service_mode_desc") || ""
  },
  getters: {
    isManageInventory(state) {
      return state.inventoryModel === "2";
    },
    isOpenDispatch(state) {
      return state.dispatchMode === "1";
    }
  },
  mutations: {
    setServiceMode(state, data) {
      state.serviceMode = data || "";
      localStorage.setItem("se_service_mode", data);
    },
    setInventoryModel(state, data) {
      // 1 不管理库存  2 管理库存
      state.inventoryModel = data || "";
      localStorage.setItem("se_inventory_model", data);
    },
    setDispatchMode(state, data) {
      // 1 开启派工  2 关闭派工
      state.dispatchMode = data || "";
      localStorage.setItem("se_service_dispatch_mode", data);
    },
    setServiceModeDesc(state, data) {
      // 管理模式 描述
      state.serviceModeDesc = data || "";
      localStorage.setItem("se_service_mode_desc", data);
    }
  },
  actions: {
    async setPrintTemplateStoreLogo({ rootState }, params = {}) {
      const data = await rootState.http("/printTemplate/setPrintTemplateStoreLogo", params);
      return data;
    },
    async reorderingPrintTemplates({ rootState }, params = {}) {
      const data = await rootState.http("/printTemplate/reorderingPrintTemplates", params);
      return data;
    },
    async updatePrintTemplateStatus({ rootState }, params = {}) {
      const data = await rootState.http("/printTemplate/updatePrintTemplateStatus", params);
      return data;
    },
    async queryPrintTemplates({ rootState }, params = {}) {
      const data = await rootState.http("/printTemplate/queryPrintTemplates", params);
      return data;
    },
    async updateServiceItemStatus({ rootState }, params = {}) {
      const data = await rootState.http("/service/item/updateServiceItemStatus", params);
      return data;
    },
    async updateSortList({ rootState }, params) {
      const data = await rootState.http("/payMethod/updateSortList", params);
      return data;
    },
    async getPatternPaymentList({ rootState }, params) {
      const data = await rootState.http("/payMethod/queryList", params);
      return data;
    },
    async updateStatusList({ rootState }, params) {
      const data = await rootState.http("payMethod/updateStatusList", params);
      return data;
    },
    async savePayMethod({ rootState }, params) {
      const data = await rootState.http("payMethod/savePayMethod", params);
      return data;
    },
    async getPcPermissionList({ rootState }, params) {
      const data = await rootState.http("resource/queryResourceList", params);
      return data;
    },
    async getRoleList({ rootState }, params) {
      const data = await rootState.http("role/queryRoleList", params);
      return data;
    },
    async createRole({ rootState }, params) {
      const data = await rootState.http("role/createRole", params);
      return data;
    },
    async updateRole({ rootState }, params) {
      const data = await rootState.http("role/updateRole", params);
      return data;
    },
    async getRoleDetail({ rootState }, params) {
      const data = await rootState.http("role/getRole", params);
      return data;
    },
    async setOrderMode({ rootState }, params) {
      const data = await rootState.http("order/setOrderMode", params);
      return data;
    },
    async queryPrintFieldListByCategory({ rootState }, params) {
      const data = await rootState.http("/printTemplate/findValidTemplateByCategory", params);
      return data;
    },
    async queryPrintFieldListByCode({ rootState }, params) {
      const data = await rootState.http("/printTemplate/findTemplateSetting", params);
      return data;
    },
    async savePrintFieldSet({ rootState }, params) {
      const data = await rootState.http("/printTemplate/updatePrintFields", params);
      return data;
    }
  }
};

export default setting;
